<template>
  <div>
    <swiper :options="swiperOption" :navigation="true" ref="swiper" class="swiper">
      <template v-for="item in filter">
        <swiper-slide v-if="year+1 == item.year" :key="item.id">
          <div :class="`noselect rm-card ${item.done ? 'done' : ''}`">
            <v-row class="d-flex flex-column">
              <v-col class="d-flex flex-row pa-0">
                <v-col class="py-0">
                  <span class="rm-card-title">{{ item.Qx }} 202{{ item.year }}</span>
                </v-col>
                <v-col class="py-0 d-flex justify-end">
                  <span class="rm-card_check">
                    <span class="rm-card_check-wrap">
                      <v-icon class="" size="16" dense color="white">
                        {{ icon.mdiCheckboxMarkedCircleOutline }}
                      </v-icon>
                    </span>
                    
                  </span>
                </v-col>
              </v-col>
              <v-col class="d-flex flex-column" cols="auto">
                <div>
                  <template v-for="(itens, index) in item.list">
                    <div class="rm-card_text" :key="index">{{ itens.text }}</div>
                  </template>
                </div>
                <!-- <span class="rm-card_text" v-for="(itens, index) in item.list" :key="index">
                  {{ itens.text }}
                </span> -->
              </v-col>
            </v-row>
          </div>
        </swiper-slide>
        <swiper-slide v-else-if="year == null" :key="item.id">
          <div class="rm-card">
            <v-row class="d-flex flex-column">
              <v-col class="d-flex flex-row pa-0">
                <v-col class="py-0">
                  <span class="rm-card-title">{{ item.Qx }} 202{{ item.year }}</span>
                </v-col>
                <v-col class="py-0 d-flex justify-end">
                  <span class="rm-card_check">
                    <span class="rm-card_check-wrap">
                      <v-icon class="" size="16" dense color="white">
                        {{ icon.mdiCheckboxMarkedCircleOutline }}
                      </v-icon>
                    </span>
                    
                  </span>
                </v-col>
              </v-col>
              <v-col class="d-flex flex-column" cols="auto">
                <div>
                  <template v-for="(itens, index) in item.list">
                    <div class="rm-card_text" :key="index">{{ itens.text }}</div>
                  </template>
                </div>
              </v-col>
            </v-row>
          </div>
        </swiper-slide>
      </template>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>

import { mdiCheckboxMarkedCircleOutline } from '@mdi/js';
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import SwiperCore, { Mousewheel, Pagination } from "swiper";

import "swiper/components/pagination/pagination.min.css";
import "swiper/swiper-bundle.min.css";

SwiperCore.use([Mousewheel, Pagination]);
export default {
  name: "RoadMap",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    year: {
      type: Number,
    },
  },
  data() {
    return {
      icon: {
        mdiCheckboxMarkedCircleOutline,
      },
      swiperOption: {
        centeredSlides: true,
        direction: "horizontal",
        grabCursor: true,
        mousewheel: false,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 50,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 150,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 50
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 50
          },
          1920: {
            slidesPerView: 4,
            spaceBetween: 10
          }
        }
      },
      backdrop: "require('@/assets/img/backdrop.png')",
      roadMapList : [
        { 
          year: 1, 
          Qx: 'Q2',
          done: true,
          list: [
            { text: 'Design of Good Game Idea' },
            { text: 'Recruiting team' },
            { text: 'Initial Prototype' },
            { text: 'Market research' },
            { text: 'Partnership with Ferrum Network' },
          ],
        },
        { 
          year: 1, 
          Qx: 'Q3',
          done: true,
          list: [
            { text: 'dApp Prototype Implementation' },
            { text: 'First Smart Contract Development' },
            { text: 'Analysis of Token Economics' },
            { text: 'Internal Testing' },
          ],
        },
        { 
          year: 1, 
          Qx: 'Q4',
          done: false,
          list: [
            { text: 'Deployment of Smart Contract into test network' },
            { text: 'Alpha testing' },
            { text: 'Betting support for main eSports events' },
            { text: 'Fundraising' },
          ],
        },
        { 
          year: 2, 
          Qx: 'Q1',
          done: false,
          list: [
            { text: 'Closed Beta' },
            { text: 'Public Fundraising' },
            { text: 'Partnership with Content Creators' },
            { text: 'Token Generation Event' },
            { text: 'Governance Voting System' },
          ],
        },
        { 
          year: 2, 
          Qx: 'Q2',
          done: false,
          list: [
            { text: 'Open Beta' },
            { text: 'NFT Marketplace Launch' },
            { text: 'Game Tracking NFT' },
            { text: 'Presence in sports and esports events' },
            { text: 'Sponsorship staking pools under team management' },
          ],
        },
        { 
          year: 2, 
          Qx: 'Q3',
          done: false,
          list: [
            { text: 'Betting into live esports matches' },
            { text: 'Support to esports tournaments' },
            { text: 'First GG sponsored esports tournament' },
            { text: 'Minting Tournament Trophy NFT' },
          ],
        },
        { 
          year: 2, 
          Qx: 'Q4',
          done: false,
          list: [
            { text: 'First in-person tournament' },
            { text: 'Partnership with game publishers and MVP proposal' },
            { text: 'New intake of partner content creators' },
            { text: 'Release of new esports node oracle' },
          ],
        },
        { 
          year: 3, 
          Qx: 'Q2',
          done: false,
          list: [
            { text: 'Sponsorship and support to selected esport team' },
            { text: 'Decentralized sponsorship pools' },
          ],
        },
      ],
    };
  },
  computed: {
    filter() {
      return this.roadMapList.filter(item => {
        if (item.year === this.year + 1) {
          return item;
        }
        else if (this.year == null) {
          return item;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.rm {
  &-card {
    @media screen and (max-width: 320px) {
      width: 240px !important;
    }
    
    @media (min-width: 640px) and (max-width: 768px) {
      width: 300px;
      padding: 15px;
    }
    
    height: 270px;
    width: 300px;
    padding: 30px;
    border-radius: 10px;
    border: 1px solid rgb(255 255 255 / 0.09); 
    box-shadow: 5px 5px rgb(255 255 255 / 0.2);

    background: linear-gradient(0deg, rgb(255 255 255 / 0.1), rgb(255 255 255 / 0.1));
    &_check {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;

      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: rgb(255 255 255 / .08);

      &-wrap {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: rgb(255 255 255 / .08);
        box-shadow: 0 1px 4px rgb(255 255 255 / 0.2);

        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &-title {
      display: flex;
      justify-content: flex-start;

      padding: 0px 0px 15px 0px;

      font-family: "Orbitron";
      font-style: normal;
      font-weight: bold;
      font-size: 25px;
      color: #eca93e;
      // color: #fff;

      line-height: unset;

      @media (max-width: 768px) {
        font-size: 20px;
      }
    }

    &_text {
      color: #fff;
      letter-spacing: .4px;
      font-size: 14px;
      line-height: 14px;
      font-weight: 500;
      text-align: left;

      padding: 0 0 20px;
      list-style-type: unset;

      &:before {
        content: "\2022";
        color: #eca93e;
        font-size: 20px;
        margin-right: 14px;
      }
    }
  }
}

.done {
  .rm {
    &-card {
      &-title {
        color: rgb(0 255 0 / .6);
      }

      &_text {
        &:before {
          color: rgb(0 255 0 / .6);
        }
      }

      &_check {
        background: rgb(0 255 0 / .08);
        &-wrap {
          background: rgb(0 255 0 / .5);
          box-shadow: 0 1px 4px rgb(0 255 0 / 0.2);
        }
      }
    }
  }
}

</style>


<style>
.swiper {
  padding-bottom: 50px; 
}

.swiper-pagination-bullet {
  background: wheat;
}


</style>